import {useEffect, useState} from "react";
import {damsFetch} from "../app/damsFetch";
import {isValidUuid} from "../app/isValidUuid";

const NOT_FOUND = {loading: false, document: null, notFound: true};

/**
 * One document, read through GET /documents/<uniqueId>, which applies the user's access (DE-1719).
 * Any failure, an empty answer or an invalid id is "not found": absent and not readable look the same.
 * @param {?string} uniqueId
 * @returns {{loading: boolean, document: ?Object, notFound: boolean}}
 */
export const useDocumentByUniqueId = (uniqueId) => {
    const valid = isValidUuid(uniqueId);
    const [state, setState] = useState(valid ? {loading: true, document: null, notFound: false} : NOT_FOUND);

    useEffect(() => {
        if (!valid) {
            setState(NOT_FOUND);
            return undefined;
        }
        let current = true;
        setState({loading: true, document: null, notFound: false});
        damsFetch(`/documents/${uniqueId}`)
            .then(document => document ? {loading: false, document, notFound: false} : NOT_FOUND)
            .catch(() => NOT_FOUND)
            .then(next => {
                if (current) {
                    setState(next);
                }
            });
        return () => {
            current = false;
        };
    }, [uniqueId, valid]);

    return state;
};
